import styled, { css } from "styled-components";

import { IThemeProps } from "@/styles";

export const QuestionTitle = styled.h1`
  font-size: ${(props: IThemeProps) => props.theme.typography.h500};
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  color: ${(props: IThemeProps) => props.theme.colors.black};
  margin-bottom: 15px;
`;

export const QuestionFieldset = styled.fieldset`
  margin: 0;
  border: 0;
  padding: 0;
  width: 100%;
  max-width: ${(props: IThemeProps) => props.theme.globals.maxInteractionWidth};
`;

export const QuestionOption = styled.div`
  background-color: #f9f9f8;
  border: 1px solid #ffffff;
  font-size: ${(props: IThemeProps) => props.theme.typography.h300};
  line-height: 1.25em;
  color: ${(props: IThemeProps) => props.theme.colors.primary};
  margin-bottom: ${(props: IThemeProps) => props.theme.spacing.desktop.s200}px;
  padding: ${(props: IThemeProps) => props.theme.spacing.desktop.s200}px 0;
  cursor: pointer;
  text-align: center;
  font-weight: 600;

  ${(props: IThemeProps) =>
    !props.theme.globals.isTouch &&
    `&:hover {
            background-color: ${props.theme.colors.primary};
            color: ${props.theme.colors.white};
            font-weight: 800;
            padding-left: ${props.theme.spacing.desktop.s100}px;
            padding-right: ${props.theme.spacing.desktop.s100}px;
        }`}
`;

export const StepWrapper = styled.div`
  display: flex; //required
  margin: 0 auto;
  max-width: 100%;
  overflow: hidden;
`;

type StepProps = IThemeProps<{
  $active: boolean;
}>;
export const Step = styled.div<StepProps>`
  margin-left: -100%; //required
  width: 100%; //required
  flex: none; //required
  opacity: 0;
  transition: all 0.4s ease;
  visibility: hidden;
  ${(props: StepProps) => props.$active && ActiveStep}
`;

const ActiveStep = css`
  margin-left: 0;
  opacity: 1;
  visibility: visible;
`;

export const Paging = styled.span`
  font-size: 12px;
  color: #000000;
`;
